/** @jsxImportSource @emotion/react */
import { SerializedStyles, css } from '@emotion/react';
import { wrap } from 'popmotion';
import React from 'react';
import {
  buttonStyle,
  greenTabs,
  slidernationTab,
  slidernationWrapper,
} from './style';

interface SlidernationProps extends React.HTMLAttributes<HTMLDivElement> {
  slideCount: number;
  activeSlide: number;
  setSlide: (arg0: number) => void;
  variant?: 'base' | 'green';
  css?: SerializedStyles;
}

const Slidernation: React.FC<SlidernationProps> = ({
  slideCount,
  activeSlide,
  variant = 'base',
  setSlide,
  css: cssProp,
  ...props
}) => {
  const sliderCount = Array.from(Array(slideCount).keys());
  const greenVariant = variant === 'green';

  const slideIndex = wrap(0, sliderCount.length, activeSlide);

  return (
    <div
      css={css`
        ${slidernationWrapper}
        ${cssProp}
      `}
    >
      {sliderCount.map((_, i) => (
        <button
          key={`slidernation-${i}`}
          onClick={() => setSlide(i)}
          css={buttonStyle}
        >
          <div
            data-active={i === slideIndex}
            css={css`
              ${slidernationTab}
              ${greenVariant && greenTabs}
              ${props?.css}
            `}
          ></div>
          <span className="sr-only">go to slide {i + 1}</span>
        </button>
      ))}
    </div>
  );
};

export default Slidernation;
